import React from "react";
import {
  getFocusStyle,
  getTheme,
  Image,
  ImageFit,
  List,
  mergeStyleSets,
  Text,
} from "@fluentui/react";

const theme = getTheme();
const { palette, semanticColors, fonts } = theme;
export const classNames = mergeStyleSets({
  container: {
    overflow: "auto",
    maxHeight: 500,
  },
  itemCell: [
    getFocusStyle(theme, { inset: -1 }),
    {
      minHeight: 54,
      padding: 10,
      boxSizing: "border-box",
      borderBottom: `1px solid ${semanticColors.bodyDivider}`,
      display: "flex",
      selectors: {
        "&:hover": { background: palette.neutralLight },
      },
      cursor:'pointer'
    },
  ],
  itemImage: {
    flexShrink: 0,
  },
  itemContent: {
    marginLeft: 10,
    overflow: "hidden",
  },
  itemName: [
    fonts.xLarge,
    {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginBottom: 10,
    },
  ],
  itemIndex: [
    fonts.small,
    {
      color: palette.neutralTertiary,
      marginBottom: 10,
    },
  ],
  chevron: {
    alignSelf: "center",
    marginLeft: 10,
    color: palette.neutralTertiary,
    fontSize: fonts.large.fontSize,
    flexShrink: 0,
  },
});

const defaultOnRenderCell = (item, index, isScrolling) => {
  return (
    <div className={classNames.itemCell} data-is-focusable={true}>
      <Image
        className={classNames.itemImage}
        src={isScrolling ? undefined : item.thumbnail}
        width={50}
        height={50}
        imageFit={ImageFit.cover}
      />
      <div className={classNames.itemContent}>
        <Text>{item.name}</Text>
        <Text>{`Item ${index}`}</Text>
      </div>
    </div>
  );
};

const BasicList = ({ items, onRenderCell }) => {
  return (
    <List items={items} onRenderCell={onRenderCell || defaultOnRenderCell} />
  );
};

export default BasicList;
